import {
  grid,
  gridColumnsRoot,
  gridColumnsTablet,
} from '../../../../utils/grid'
import React, { FunctionComponent } from 'react'
import Video, { VideoProps } from '../../../molecules/video/Video'
import { mediaQueries } from '../../../../utils/mediaQueries'
import { rem } from '../../../../utils/rem'
import { SectionProps } from '../Sections'
import { spacing } from '../../../../utils/spacing'
import { spacings } from '../../../../tokens/Spacings'
import styled from 'styled-components'

export interface VideoSectionProps extends VideoProps, SectionProps {}

const VideoSection: FunctionComponent<VideoSectionProps> = ({
  className,
  title,
  vimeoId,
  youkuId,
}) => {
  if (!vimeoId || !youkuId) {
    return null
  }

  return (
    <StyledVideoSection>
      <VideoWrapper>
        <Video
          className={className}
          title={title}
          vimeoId={vimeoId}
          youkuId={youkuId}
        />
      </VideoWrapper>
    </StyledVideoSection>
  )
}

const StyledVideoSection = styled.div`
  ${grid()}
  ${spacing()}
`

const VideoWrapper = styled.div`
  grid-column: 1 / span ${gridColumnsRoot};
  margin: 0 -${rem(spacings.side.root / 2)};

  ${mediaQueries.tablet} {
    grid-column: 1 / span ${gridColumnsTablet};
    margin: 0 -${rem(spacings.side.tablet / 2)};
  }

  ${mediaQueries.desktop} {
    grid-column: 3 / span 12;
    margin: 0;
  }
`

export default VideoSection
